import { render, staticRenderFns } from "./forgetUserName.vue?vue&type=template&id=64237336"
import script from "./forgetUserName.vue?vue&type=script&lang=js"
export * from "./forgetUserName.vue?vue&type=script&lang=js"
import style0 from "./forgetUserName.vue?vue&type=style&index=0&id=64237336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports